import { defineMessages } from 'react-intl';

export default defineMessages({
    nonPayStatusMessage: {
        id: 'ml.common.component.MLSelectPaymontAmount.You have one or more policies with an outstanding balance.  You need to pay at least the current amount due to keep your policy(s) active.',
        defaultMessage: 'You have one or more policies with an outstanding balance.  You need to pay at least the current amount due to keep your policy(s) active.'
    },
    onetimePaymentMessage: {
        id: 'ml.common.component.MLSelectPaymontAmount.To make a one-time payment, choose an option below:',
        defaultMessage: 'To make a one-time payment, choose an option below:'
    },
    headerOptionText: {
        id: 'ml.common.component.MLSelectPaymontAmount.Option',
        defaultMessage: 'OPTION'
    },
    headerAmountText: {
        id: 'ml.common.component.MLSelectPaymontAmount.Amount',
        defaultMessage: 'AMOUNT'
    },
    currentAmountDue: {
        id: 'ml.common.component.MLSelectPaymontAmount.Current amount due',
        defaultMessage: 'Current amount due'
    },
    contactUsToReinstate: {
        id: 'ml.common.component.MLSelectPaymontAmount.Once a payment has been made, contact us to reinstate the policy.',
        defaultMessage: 'Once a payment has been made, contact us to reinstate the policy.'
    },
    mustBePaidInFull: {
        id: 'ml.common.component.MLSelectPaymontAmount.The Current amount due must be paid in full to reinstate the policy.',
        defaultMessage: 'The <b>Current amount due</b> must be paid in full to reinstate the policy.'
    },
    autoPolicy: {
        id: 'ml.common.component.MLSelectPaymontAmount.Auto Policy',
        defaultMessage: 'Auto Policy'
    },
    homePolicy: {
        id: 'ml.common.component.MLSelectPaymontAmount.Home Policy',
        defaultMessage: 'Home Policy'
    },
    umbrellaPolicy: {
        id: 'ml.common.component.MLSelectPaymontAmount.Umbrella Policy',
        defaultMessage: 'Umbrella Policy'
    },
    policyNumber: {
        id: 'ml.common.component.MLSelectPaymontAmount.PolicyNumber',
        defaultMessage: '#{policyNumber}'
    },
    policyBalance: {
        id: 'ml.common.component.MLSelectPaymontAmount.Policy Balance:',
        defaultMessage: 'Policy Balance:'
    },
    amountDueToReinstate: {
        id: 'ml.common.component.MLSelectPaymontAmount.Amount due to reinstate cancelled policy',
        defaultMessage: 'Amount due to reinstate cancelled policy'
    },
    entireBalance: {
        id: 'ml.common.component.MLSelectPaymontAmount.Entire Balance',
        defaultMessage: 'Entire Balance'
    },
    otherAmount: {
        id: 'ml.common.component.MLSelectPaymontAmount.Other amount',
        defaultMessage: 'Other amount'
    },
    enterAmount: {
        id: 'ml.common.component.MLSelectPaymontAmount.Enter amount',
        defaultMessage: 'Enter amount'
    },
    minAmount: {
        id: 'ml.common.component.MLSelectPaymontAmount.Minimum value is 1',
        defaultMessage: 'Minimum value is 1'
    },
    maxAmount: {
        id: 'ml.common.component.MLSelectPaymontAmount.Maximum value is',
        defaultMessage: 'Maximun value is {max}'
    },
    requiredField: {
        id: 'ml.common.component.MLSelectPaymontAmount.This is a required field.',
        defaultMessage: 'This is a required field.'
    }
});